import { Button, TextLink } from "@vds/buttons";
import { Row } from '@vds/grids';
import TravelPass from '@vds/icons/travel-pass';
import { Input } from "@vds/inputs";
import { Notification } from "@vds/notifications";
import { Body, Title } from '@vds/typography';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useGetConfirmationByNameQuery, useLazyGetSendEmailByNameQuery } from '../../features/confirmation/confirmationFetch';
import DeviceDetails from '../../shared/components/DeviceDetails';
import FullPageLoader from '../../shared/components/Loader';
import { isDesktop, isTab, isNative, unauth, nativeLoginEnablementFFlag, L2WebpunchoutUrl, confirmPlanDualCallFixFFlag, isACSS, isPOS, nsaItpAcssPosFlowEnablementFFlag, unauthItpNsaInflightOnlyFFlag, emailFormatValidationFFlag, unauthItpNsaFFlag,reloadRedirectFixFFlag} from '../../shared/utils/globalConfig';
import { addSpace, getDestList } from '../../shared/utils/globalUtils';
import { useDispatch, useSelector } from 'react-redux';
import ErrorPage from "../../shared/components/ErrorPage";
import { dispatchNotifyEvent, setConfimedPlanDetail } from '../../shared/utils/tagging'
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { nativeOpenInWebview, openNativeSign } from '../../shared/utils/native';
import { validate as validateEmail } from 'react-email-validator';

import { saveSelectedDestinations } from '../../features/selectedData/selectedDataReducer';
import { savePersistantDestinations,savePersistantDates, setOnlyCruise} from '../../features/selectedData/persistantDataReducer';
import { setRetainDatesAndDestinations,setConfirmationPage } from '../../features/selectedData/selectedDataReducer';
import { updateSelectedPlanData, saveSelectedDeviceDetails } from '../../features/selectedData/selectedDataReducer';
import { saveConfirmedPlanData } from '../../features/selectedData/persistantDataReducer';
import Cookies from 'js-cookie';
import xss from 'xss';

const ConfirmationMain = styled.div`
`
const Space = styled.div`
padding-top: ${props => props.pt || 12}px;
`
const PaddingSpace = styled.div`
padding-right: 8px;
`

const StyledTripDetails = styled.div`
border-radius: 16px;
background: var(--gray-95, #F6F6F6);
width:${isDesktop || isTab ? '50%' : ''};
height:10%;
padding:20px;
`;

const StyledEmailDiv = styled.div`
display:${isACSS || isPOS ? '' : 'flex'};
width: Fill (808px)px;.
height: Hug (240px)px;
padding: 16px 0px 0px 0px;
gap: 10px;
border-radius: 16px 0px 0px 0px;
opacity: 0px;

`
const StyledEmailDetailsDiv = styled.div`
display:flex;

`

const StyledButton = styled(Button)`
height:10%;
margin-top:20px;
`

const StyledInput = styled(Input)`


`
const StyledBlock = styled.div`
display: flex;
gap: 3px;
`

const StyledTextDiv = styled.div`
display:flex;
width:${isDesktop || isTab ? '40%' : ''};
`
const StyledTitle = styled.div`
width:${isDesktop || isTab ? '40%' : ''};
`

const DisplayButton = (confirmationData) => {
 return( unauth? confirmationData?.uaSignInButton :confirmationData?.exploreButton)
    
}
export default function Confirmation() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loadConfirmPage } = useSelector(state => state?.selectedReducer);
    const { confirmedPlanData } = useSelector(state => state?.persistantReducer);
    const { selectedDestinations, selectedDates, devicesData,selectedDeviceDetailsUnauth } = useSelector(state => state?.persistantReducer);
    const [emailErrorMessage,setEmailErrorMessage] = useState();
    const [errorCode,setEmailErrorCode] = useState(false);
    const getDevicesPayload = () => {
        let payload = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthSessionId" :""
        }
        return payload;
    }
    const { data: devicesDatas } = useGetDevicesAndPlansByNameQuery(getDevicesPayload(),
    { skip: confirmPlanDualCallFixFFlag || (selectedDestinations && selectedDestinations.length==0) || unauth})

    const emailElementRef = useRef(null);
    const getConfPayload = () => {
        const payload = confirmedPlanData.map(item => {
            return {
                "mtn": item?.mtn,
                "formattedMtn": item?.formattedMtn,
                "deviceImageUrl": item?.deviceImageUrl,
                "deviceImageAlt": item?.deviceImageAlt,
                "role": item?.role,
                "deviceNickName": item?.deviceNickName,
                "canadaMexicoCovered": item?.canadaMexicoCovered,
                "features": item?.featuresConfirm,
                "effectiveDate": item?.effectiveDate,
                "mtnHashCode": item?.mtnHashCode,
                "unlimitedUltimateFlag": item?.unlimitedUltimateFlag
            }
        })
        return { 'confirmedPlanData': payload };
    }
    const getConfPayloadUnauth = () => {
        let destinationSelected = getDestList(selectedDestinations, 'key')
        let onlyAirPlane = destinationSelected && destinationSelected.length == 1 && destinationSelected[0] ==='AAA' ? true : false
        let payload;
        if(onlyAirPlane && unauthItpNsaInflightOnlyFFlag){
            payload = [{
                "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
                "deviceImageAlt": selectedDeviceDetailsUnauth?.deviceImageAlt,
            }]
        }
        else{
        payload = confirmedPlanData.map(item => {
            return {
                "mtn": item?.mtn,
                "sorId":item?.sorId,
                "deviceImageUrl": item?.deviceImageUrl,
                "deviceImageAlt": item?.deviceImageAlt,
                "deviceNickName": item?.deviceNickName,
                "features": item?.features
            }
        })}
        return { 'confirmedPlanData': payload };
    }
    const getFeatures = (plans) => {
        const features = plans?.map((plan) => {
            return {
                "currentPlanId": plan?.planId,
                "newPlanId": plan?.planId,
                "currentPlanCategory": plan?.category,
                "newPlanCategory": plan.category,
                "planType": plan?.planType,
                "quantity": "1"
            }
        })
        return features;
    }

    const getConfirmedEmailData = (onlyAirPlane) => {
        let payload;
        if (confirmedPlanData?.length > 0) {
            payload = confirmedPlanData.map(item => {
                return {
                    "mtn": item?.mtn,
                    "formattedMtn": item?.formattedMtn,
                    "deviceImageUrl": item?.deviceImageUrl,
                    "role": item?.role,
                    "deviceNickName": item?.deviceNickName,
                    "canadaMexicoCovered": item?.canadaMexicoCovered,
                    "features": item?.featuresConfirm,
                    "effectiveDate": item?.effectiveDate,
                    "recommendedOfferName": item?.recommendedOfferName,
                    "brandName": item?.brandName,
                    "operatingSystem": item?.operatingSystem
                }
            })
        }
        else {
            let deviceDetails;
            if (confirmPlanDualCallFixFFlag) {
                if (onlyAirPlane) {
                    deviceDetails = devicesData?.filter((device) => device?.travelReady)
                }
                else {
                    deviceDetails = devicesData?.filter((device) => device?.travelReady && device?.currentPlanDetails?.length > 0);
                }
            }
            else {
                if (onlyAirPlane) {
                    deviceDetails =  devicesDatas?.body?.data?.devicesAndPlans?.deviceDetails?.filter((device) => device?.travelReady)
                }
                else { deviceDetails =  devicesDatas?.body?.data?.devicesAndPlans?.deviceDetails?.filter((device) => device?.travelReady && device?.currentPlanDetails?.length > 0); }
            }

            if (deviceDetails?.length > 0) {
                let data = deviceDetails[0];
                payload = [{
                    "mtn": data?.mtn,
                    "formattedMtn": data?.formattedMtn,
                    "deviceImageUrl": data?.deviceImageUrl,
                    "role": data?.role,
                    "deviceNickName": data?.deviceNickName,
                    "canadaMexicoCovered": data?.canadaMexicoCovered,
                    "features": getFeatures(data?.currentPlanDetails),
                    "effectiveDate": data?.effectiveDate,
                    "recommendedOfferName": data?.planRecommendationInfo?.planName,
                    "brandName": data?.brandName,
                    "operatingSystem": data?.operatingSystem
                }]
            }
        }

        return payload;
    }
    const getSendEmailAndRemarksPayload = (params) => {
        let destinationSelected = getDestList(selectedDestinations, 'key')
        let onlyAirPlane = destinationSelected && destinationSelected.length == 1 && destinationSelected[0] ==='AAA' ? true : false
       
        let payload = {
            'emailId': emailElementRef?.current?.value,
            'confirmedPlanData': getConfirmedEmailData(onlyAirPlane),
            'actionLabel':params
        }
        return payload;
    }
    const Payload = unauth ? getConfPayloadUnauth() : getConfPayload();
    //load confirmpage will be true only when user clicks confirm button in devicespage
    const { data, error, isLoading, isSuccess } = useGetConfirmationByNameQuery(Payload,
    { skip:((!loadConfirmPage && !unauth) || (selectedDestinations?.length === 0) 
    )});

    const [confirmationData, setConfirmationData] = useState();

    useEffect(() => {
        setConfirmationData(data?.body?.data?.confirmation);
        setFlightReviewDetailObject(data?.body?.data?.inFlightReviewDetailObject)
    }, [data]);

    //Redirect to destination, if destination and travel dates are empty
    useEffect(() => {
        if (reloadRedirectFixFFlag && (selectedDestinations.length === 0 || selectedDates?.travelEndDate == undefined && selectedDates?.travelStartDate == undefined)) {
            if (unauth) {
                window.location.href = xss('/digital/nsa/nos/ui/intl/trip/');
            }
            else {
                window.location.href = xss('/digital/nsa/secure/ui/intl/trip/');
            }
        }
    }, [])

    //when user clicks on confirmation back arrow (component unmount)
    useEffect(() => {
        return () => {
            if (unauth) {
                dispatch(saveConfirmedPlanData([]));
                dispatch(updateSelectedPlanData({}));
            }
            else {
                dispatch(saveSelectedDestinations([]));
                dispatch(savePersistantDestinations([]));
                dispatch(savePersistantDates({}));
                dispatch(setRetainDatesAndDestinations(false));
                if ((isACSS || isPOS) && nsaItpAcssPosFlowEnablementFFlag)
                    window.location.href = '/digital/nsa/secure/ui/intl/trip/itpdestination'
                else
                window.location.href = '/digital/nsa/secure/ui/intl/'
                
            }

        }
    }, [])

    useEffect(() => {
        if (!loadConfirmPage) { 
            if(!unauth)
            {
                dispatch(updateSelectedPlanData({}));
                dispatch(saveSelectedDeviceDetails({})); 
                dispatch(saveSelectedDestinations([]));
                dispatch(savePersistantDestinations([]));
                dispatch(savePersistantDates({}));
                dispatch(setRetainDatesAndDestinations(false));
                dispatch(setConfirmationPage(false));
                if ((isACSS || isPOS) && nsaItpAcssPosFlowEnablementFFlag)
                    navigate("/itpdestination")
                else
                window.location.href = '/digital/nsa/secure/ui/intl/';}
        }
    }, [loadConfirmPage])


    useEffect(() => {
        if (confirmationData)
            setConfimedPlanDetail(confirmationData, '#confirmation_page')
    }, [confirmationData])


    const [disableEmail, setDisableEmail] = useState(true);
    const [triggerHandleRemarksAndSendEmailButtonClick, sendEmailAndRemarksResponse] = useLazyGetSendEmailByNameQuery(getSendEmailAndRemarksPayload());
    const [flightReviewDetailObject, setFlightReviewDetailObject] = useState();

    //Tagging
    useEffect(() => {
        if (sendEmailAndRemarksResponse?.isSuccess) {
            dispatchNotifyEvent(confirmationData?.emailNotification, "00")
        }
        if (sendEmailAndRemarksResponse?.isError) {
            dispatchNotifyEvent(sendEmailAndRemarksResponse?.error?.data?.responseInfo.sectionErrors[0]?.externalErrorMessage, "99")
            setEmailErrorMessage(sendEmailAndRemarksResponse?.error?.data?.responseInfo.sectionErrors[0]?.externalErrorMessage)
            if(sendEmailAndRemarksResponse?.error?.data?.responseInfo?.responseCode != '512')
            setEmailErrorCode(true)
        }


    }, [sendEmailAndRemarksResponse])

    const handleRemarksAndSendEmailButtonClick = (params) => {
        triggerHandleRemarksAndSendEmailButtonClick(getSendEmailAndRemarksPayload(params));
        
    }

    const handleInputChange = (event) => {
        if (event.target.value.length > 0) {
            isValidEmailCheck();
        }
        else {
            setDisableEmail(true);
        }
    }
    const onExploreButtonClick = () => {
        if(!confirmPlanDualCallFixFFlag)
        {
            dispatch(saveConfirmedPlanData([]));
        }
        dispatch(updateSelectedPlanData({}));
        dispatch(saveSelectedDeviceDetails({})); 
        dispatch(saveSelectedDestinations([]));
        dispatch(savePersistantDestinations([]));
        dispatch(savePersistantDates({}));
        dispatch(setRetainDatesAndDestinations(false));
        dispatch(setConfirmationPage(false));
        dispatch(setOnlyCruise(false));
        if (unauth) {
            Cookies.set('NsaUnAuthSessionId', confirmationData?.unAuthSessionId);
            if(nativeLoginEnablementFFlag && isNative){
            openNativeSign(L2WebpunchoutUrl, window.location.origin + "/digital/nsa/secure/ui/intl/trip/itpdevicesandplans");}
            else{
                window.location.href = "/digital/nsa/secure/ui/intl/trip/itpdevicesandplans";}
        }
        else {
            if ((isACSS || isPOS) && nsaItpAcssPosFlowEnablementFFlag)
            window.close();
            else
            window.location.href = confirmationData?.confirmButtonLink
        }
       
       
        
    }
    const isValidEmailCheck = () => {
        let validEmailAddresses = []
        let invalidEmailAddresses = []
        let EmailsTempArray = []

        EmailsTempArray = emailElementRef.current.value?.toString()?.split(",");
        //let validRegex = "^[\\w-]+(?:\\.[\\w-]+)*@(?:[\\w-]+\\.)+[a-zA-Z]{2,7}$"
        let i;
        if (EmailsTempArray?.length > 0) {
            for (i = 0; i < EmailsTempArray.length; i++) {
                // if (EmailsTempArray[i].trim().match(validRegex))
                    if (validateEmail(EmailsTempArray[i].trim()))
                    validEmailAddresses.push(EmailsTempArray[i])
                else {
                    invalidEmailAddresses.push(EmailsTempArray[i])
                    setDisableEmail(true);
                }
            }
            if (invalidEmailAddresses.length == 0) {
                setDisableEmail(false);
                return true
            }
        }
    }

    const openFooterLink = (link) => {
        if (isNative) {
            nativeOpenInWebview(link);
        } else {
            window.open(link);
        }
    }

    const renderEmailDetails = (confirmationData) => {
        return (<StyledTripDetails>
            <Title size="large">{confirmationData?.tripText}</Title>
            <Space />
            <Body size="large">{confirmationData?.travelDates}</Body>
            <StyledBlock><Body size="large">{confirmationData?.travelLabel}</Body>
                <Body size="large" bold={true}>{addSpace(confirmationData?.travelingCountries, ',')}</Body>
            </StyledBlock>
            {sendEmailAndRemarksResponse?.isSuccess &&
                <>
                    <Space pt={24} />
                    <Notification
                        type="success"
                        hideCloseButton={true}
                        title={sendEmailAndRemarksResponse?.data?.body?.data?.sendEmailUpdateDetails?.title}
                        fullBleed={false}
                        inline={false}
                        disableFocus={true}
                    />
                    <Space pt={12} /></>}
            {sendEmailAndRemarksResponse?.isError && emailErrorMessage && emailFormatValidationFFlag &&
                <>
                    <Space pt={24} />
                    <Notification
                        type="error"
                        hideCloseButton={true}
                        title={emailErrorMessage}
                        fullBleed={false}
                        inline={false}
                        disableFocus={true}
                    />
                    <Space pt={12} /></>}
            {!unauth && <StyledEmailDiv>
                <StyledInput
                    type='email'
                    data-testid="confirmation-email-input"
                    ref={emailElementRef}
                    label={confirmationData?.emailText}
                    readOnly={false}
                    disabled={sendEmailAndRemarksResponse?.isSuccess || errorCode}
                    error={false}
                    errorText='Enter a valid address.'
                    helperText={confirmationData?.emailHelperText}
                    helperTextPlacement="bottom"
                    onChange={(e) => { handleInputChange(e) }}
                    onPaste={(e) => {
                        e.preventDefault()
                        return false;
                    }} onCopy={(e) => {
                        e.preventDefault()
                        return false;
                    }}
                />
                {!(isACSS || isPOS) && 
                <StyledButton
                    size="medium"
                    data-testid="send-email-button"
                    disabled={disableEmail || sendEmailAndRemarksResponse?.isSuccess || errorCode}
                    onClick={() => { handleRemarksAndSendEmailButtonClick("SendEmail") }}
                    use="primary"
                    ariaLabel="Send additional emails for this trip">
                    {confirmationData?.emailLabel}
                </StyledButton>}
                {(isACSS || isPOS) && nsaItpAcssPosFlowEnablementFFlag &&
                    <>
                    <StyledEmailDetailsDiv>
                        <StyledButton
                            size="medium"
                            data-testid="sendEmailAndGenerateRemarks button"
                            disabled={disableEmail || sendEmailAndRemarksResponse?.isSuccess || errorCode}
                            onClick={() => { handleRemarksAndSendEmailButtonClick("SendEmailandGenerateRemarks") }}
                            use="primary"
                            ariaLabel="sendEmailAndGenerateRemarks">
                            {confirmationData?.sendEmailAndGenerateRemarksLabel}
                        </StyledButton>
                        <PaddingSpace></PaddingSpace>
                        <StyledButton
                            size="medium"
                            data-testid="generateRemarks button"
                            disabled={sendEmailAndRemarksResponse?.isSuccess || errorCode}
                            onClick={() => { handleRemarksAndSendEmailButtonClick("GenerateRemarks") }}
                            use="primary"
                            ariaLabel="generateRemarks">
                            {confirmationData?.generateRemarksLabel}
                        </StyledButton></StyledEmailDetailsDiv></>}
            </StyledEmailDiv>}
        </StyledTripDetails>)
    }


    return (
        <ConfirmationMain id="confirmation_page">
            {(isSuccess && !sendEmailAndRemarksResponse?.isLoading && confirmationData) ?
                (<>
                    <StyledTitle>{unauth &&<Title size="XLarge">{ confirmationData?.uaHeading }</Title>}
                    {!unauth && <Title size="XLarge">{confirmationData?.heading}</Title>}
                    </StyledTitle>
                    <Space pt={24} />
                    {confirmationData?.subText && !unauth &&
                        <>
                            <Title size="small" color="#6F7171">{confirmationData?.subText}</Title>
                            <Space pt={12} /></>}
                    {confirmationData?.uaSubText && unauth &&
                        <>
                            <Title size="small" color="#6F7171">{confirmationData?.uaSubText}</Title>
                            <Space pt={12} /></>}

                    {renderEmailDetails(confirmationData)}
                    <Space pt={24} />
                    {confirmationData?.summaryText && confirmationData?.summarySubText &&
                        <>
                            <Title size="large">{confirmationData?.summaryText}</Title>
                            <Space pt={24} />
                            <StyledTextDiv>
                                <TravelPass
                                    color="#0089EC"
                                    size="XLarge"
                                />
                                <Body size="medium">{confirmationData?.summarySubText}</Body>
                            </StyledTextDiv>
                            <Space pt={24} /></>}
                    {confirmationData?.deviceDetails &&
                        <>
                            <Row>
                                {confirmationData?.deviceDetails?.map((deviceDetailInfo, i) => (
                                    <DeviceDetails
                                    deviceDetailInfo={deviceDetailInfo}
                                    onlyAirPlane={confirmationData?.onlyAirPlane}
                                    flightReviewDetailObject={flightReviewDetailObject}
                                    domesticTooltip={confirmationData?.domesticTooltip}
                                    pageType={'confirm'}></DeviceDetails>
                                ))}</Row>
                            <Space pt={24} /></>}

                    <Space pt={24} />
                    <Title size="large">{confirmationData?.nextStepText}</Title>
                    <Space />
                    {unauth && <Body size="medium">{confirmationData?.uaNextStepSubText}</Body>}
                    {!unauth && <Body size="medium">{confirmationData?.nextStepSubText}</Body>}
                    <Space pt={24} />
                    <Button
                        size="large"
                        width={(isDesktop || isTab) ? '30%' : '100%'} onClick={() => { onExploreButtonClick() }}>
                        {DisplayButton(confirmationData)}</Button>
                    <Space pt={24} />
                    {confirmationData?.footerLinks?.map((footNote) => (
                        <Body> <TextLink ariaLabel={`${footNote?.linkText} link`} onClick={() => { openFooterLink(footNote?.linkUrl) }} size="medium">
                            {footNote?.linkText}
                            <Space pt={16}></Space>
                        </TextLink></Body>
                    ))}

                </>
                )
                : (error && <ErrorPage errorDetails={error?.data} />)
            }
            {(isLoading || sendEmailAndRemarksResponse?.isLoading) && <FullPageLoader />}
        </ConfirmationMain>
    )
} 